import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BarChart3, NotebookText, LayoutGrid, NotepadText, Sheet } from 'lucide-react';
import { useAuth } from '../AuthContext';
import './DashboardMenuHeader.css';

const FacturacionMenuHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasAccess } = useAuth();

  const menuItems = [
    { path: '/kpi-fact', label: 'KPIs Facturación', icon: BarChart3 },
    { path: '/detalle-fact', label: 'Detalle Facturas', icon: NotebookText },
    { path: '/detalle-notascredito', label: 'Detalle N. Crédito', icon: NotepadText },
    { path: '/panel-notascredito', label: 'Panel N. Crédito', icon: Sheet},
  ];
  const visibleMenuItems = menuItems.filter(item => hasAccess(item.path));

  return (
    <motion.div
      className="dashboard-menu-header"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="header-left">
        {hasAccess('/facturación') && (
          <button className="nav-icon-btn back-btn" onClick={() => navigate('/facturación')} title="Volver al Menú">
            <LayoutGrid size={20} />
          </button>
        )}
        <div className="vertical-divider"></div>
      </div>
      <div className="header-nav-items">
        {visibleMenuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              className={`nav-tab-item ${isActive ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <item.icon size={16} className="tab-icon" />
              <span className="tab-label">{item.label}</span>
              {isActive && (
                <motion.div
                  className="active-tab-indicator"
                  layoutId="activeTabIndicator"
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
              )}
            </button>
          );
        })}
      </div>
      
    </motion.div>
  );
};

export default FacturacionMenuHeader;